import {atom} from "recoil";

/**
 * 최대 결재자 수 제한
 * @type {RecoilState<number>}
 */
export const approverMaxAtom = atom({
    key: "approverMaxAtom"
    , default: 4
})